import type { ReactNode } from 'react';

import { cx } from 'cva';
import {
  Popover as RACPopover,
  type PopoverProps as RACPopoverProps,
} from 'react-aria-components/Popover';

import styles from './popover.module.css';

export type PopoverProps = RACPopoverProps & {
  children?: ReactNode;
};

/**
 * Popover component that can be used to display content in a floating container.
 *
 * Use `Popover` to show additional content or actions related to a specific element.
 *
 * See https://react-spectrum.adobe.com/react-aria/Popover.html for the underlying
 * implementation.
 *
 * ```tsx
 * <Popover>
 *  <div>Popover content</div>
 * </Popover>
 * ```
 */
export const Popover = ({ className, children, ...props }: PopoverProps) => {
  return (
    <RACPopover className={cx(styles.popover, className)} offset={8} {...props}>
      {children}
    </RACPopover>
  );
};
